import VendorStockContainer from '@components/containers/vendorStock';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

/** Raw and packaging material only — the Stock container pinned to its material view. */
const VendorRmPm: FC = () => (
    <VendorLayout>
        <VendorStockContainer fixedView="material" />
    </VendorLayout>
);

export default VendorRmPm;
